import * as d from "react";
import h, { useRef as l } from "react";
import { n as m, t as f } from "./index-CjjiqU7h.mjs";
const x = ["xxl", "xl", "lg", "md", "sm", "xs"], $ = (n) => ({
  xs: `(max-width: ${n.screenXSMax}px)`,
  sm: `(min-width: ${n.screenSM}px)`,
  md: `(min-width: ${n.screenMD}px)`,
  lg: `(min-width: ${n.screenLG}px)`,
  xl: `(min-width: ${n.screenXL}px)`,
  xxl: `(min-width: ${n.screenXXL}px)`
}), b = (n) => {
  const e = n, t = [].concat(x).reverse();
  return t.forEach((a, o) => {
    const s = a.toUpperCase(), i = `screen${s}Min`, r = `screen${s}`;
    if (!(e[i] <= e[r]))
      throw new Error(`${i}<=${r} fails : !(${e[i]}<=${e[r]})`);
    if (o < t.length - 1) {
      const c = `screen${s}Max`;
      if (!(e[r] <= e[c]))
        throw new Error(`${r}<=${c} fails : !(${e[r]}<=${e[c]})`);
      const u = `screen${t[o + 1].toUpperCase()}Min`;
      if (!(e[c] <= e[u]))
        throw new Error(`${c}<=${u} fails : !(${e[c]}<=${e[u]})`);
    }
  }), n;
};
function M() {
  const [, n] = m(), e = $(b(n));
  return h.useMemo(() => {
    const t = /* @__PURE__ */ new Map();
    let a = -1, o = {};
    return {
      matchHandlers: {},
      dispatch(s) {
        return o = s, t.forEach((i) => i(o)), t.size >= 1;
      },
      subscribe(s) {
        return t.size || this.register(), a += 1, t.set(a, s), s(o), a;
      },
      unsubscribe(s) {
        t.delete(s), t.size || this.unregister();
      },
      unregister() {
        Object.keys(e).forEach((s) => {
          const i = e[s], r = this.matchHandlers[i];
          r == null || r.mql.removeListener(r == null ? void 0 : r.listener);
        }), t.clear();
      },
      register() {
        Object.keys(e).forEach((s) => {
          const i = e[s], r = (p) => {
            let {
              matches: u
            } = p;
            this.dispatch(Object.assign(Object.assign({}, o), {
              [s]: u
            }));
          }, c = window.matchMedia(i);
          c.addListener(r), this.matchHandlers[i] = {
            mql: c,
            listener: r
          }, r(c);
        });
      },
      responsiveMap: e
    };
  }, [n]);
}
function g() {
  const [, n] = d.useReducer((e) => e + 1, 0);
  return n;
}
function U() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  const e = l({}), t = g(), a = M();
  return f(() => {
    const o = a.subscribe((s) => {
      e.current = s, n && t();
    });
    return () => a.unsubscribe(o);
  }, []), e.current;
}
export {
  x as r,
  U as u
};
//# sourceMappingURL=useBreakpoint-C_VPG-kZ.mjs.map
